/*
eslint-disable
 */
import React from 'react';

export function PositionHandler({ positionStyle, children, instance }) {

  const fixedWidth = instance && instance.fixedWrapperStyle && instance.fixedWrapperStyle.width;
  const fixedHeight = instance && instance.fixedWrapperStyle && instance.fixedWrapperStyle.height;
  const commonWidth = instance && instance.commonStyle && instance.commonStyle.width;
  const styleOBj = {
    ...positionStyle,
    width: fixedWidth || (commonWidth ? 'auto' : '100%'),
    height: fixedHeight || 'auto',
    zIndex: 999,
  };

  return <div style={styleOBj}>{children}</div>;
}
